import React, {useEffect, useState} from 'react';
import {Button, Card, Container, Modal, ModalBody, ModalHeader, Spinner,} from 'reactstrap';
import {doc, getDoc, updateDoc} from 'firebase/firestore';
import {getDb} from 'util/Constants';
import DataTable from 'react-data-table-component'
import ProgressGamesModal from './ProgressGamesModal';
import Swal from "sweetalert2";


function ProgressGames() {
    const [games, setGames] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [load, setLoad] = useState(true)
    const [btnLoad, setBtnLoad] = useState(null);

    const column = [
        {
            name: 'Tab Name',
            selector: row => row.tabName,
        },
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Logo',
            center: true,
            selector: (row) => <img src={row.image} width="50" alt="Logo" />
        },
        {
            name: 'Level Objective',
            minWidth: '20%',
            wrap: true,
            center: true,
            selector: row => row.goalText,
            cell: row => {
                return (
                    <div className="small">
                        {row.goalText}
                    </div>
                )
            }
        },
        {
            name: "Passing Score",
            selector: row => row.passingScore,

        }, {

            name: "Time",
            selector: row => row.time,
        },
        {

            name: '',
            width: '250px',
            selector: row => null,
            cell: row => (
                <div className="d-flex justify-content-end w-100 px-2">
                    <Button
                        onClick={() => toggleModal(row)}
                        color="default"
                        size="sm"
                    >
                        <i className="fas fa-pen" />
                    </Button>

                    <Button
                        onClick={() => deleteData(row)}
                        disabled={btnLoad === row.tabName}
                        color="danger"
                        size="sm"
                    >{btnLoad === row.tabName ?
                        <Spinner
                            className="mx-2"
                            color={'white'}
                            size={'sm'}
                        >
                            Loading...
                        </Spinner> : <i className="fas fa-trash" />}
                    </Button>
                </div>
            )
        }

    ];
    const toggleModal = (item) => {
        if (item?.hasOwnProperty("name")) {

            setSelectedItem(item);
        }
        else {

            setSelectedItem({})
        }
        setModalOpen((prev) => !prev);
    };

    const deleteData = async (item) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will permanently delete the Mini game!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            // reverseButtons: true,
        });

        // If user cancels, stop the deletion process
        if (!result.isConfirmed) return;
        setBtnLoad(item.tabName)
        const gamesData = games.filter((e) => e.tabName !== item.tabName)
        const metaGamesRef = doc(getDb(), "Metadata_Games", "games");
        await updateDoc(metaGamesRef, {
            data: gamesData
        });
        setGames(gamesData)
        setBtnLoad(null)
    }



    useEffect(() => {
        const fetchData = async () => {
            const docRef = doc(getDb(), 'Metadata_Games', 'games');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data().data;
                setGames(data)

                setLoad(false)

            } else {
                setLoad(false)

            }
        }
        fetchData();
    }, []);

    return (
        <>
            <Container fluid>
                <div className='d-flex justify-content-end'>
                    <Button
                        onClick={toggleModal}
                        color="default"
                    >
                        Add
                    </Button>
                </div>
                <Card>
                    <DataTable
                        columns={column}
                        data={games}
                        progressPending={load}
                        pagination={true}

                    />
                </Card>
            </Container>
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{selectedItem?.hasOwnProperty('name') ? 'Update' : 'Add'} Mini Games</ModalHeader>
                <ModalBody>
                    <ProgressGamesModal isOpen={modalOpen} toggle={toggleModal} item={selectedItem} games={games} setGames={setGames} />
                </ModalBody>
            </Modal>
        </>
    )
}

export default ProgressGames
